var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33341 1.33325L25.6667 22.6666M17.6667 14.9814C16.9591 15.6148 16.0246 15.9999 15.0001 15.9999C12.7909 15.9999 11.0001 14.2091 11.0001 11.9999C11.0001 10.9754 11.3852 10.0409 12.0186 9.33325M25.1438 16.8102C25.9056 16.1469 26.5871 15.4798 27.1738 14.8625C28.7199 13.2357 28.7199 10.7641 27.1738 9.13738C24.5661 6.3937 20.0874 2.66659 15.0001 2.66659C13.8116 2.66659 12.6563 2.87 11.5503 3.21677M7.66675 5.0711C5.722 6.3125 4.0636 7.83563 2.82636 9.13738C1.28021 10.7641 1.28021 13.2357 2.82636 14.8625C5.43407 17.6061 9.91273 21.3333 15.0001 21.3333C17.4909 21.3333 19.8357 20.4398 21.8865 19.2058",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon1);
export default __webpack_public_path__ + "static/media/appIcon1.5b2ea7da45516d91c31e30fb5567b491.svg";
export { ForwardRef as ReactComponent };